<template>
    <div class="form">
        <div v-if="overlayOn" class="overlay"></div>
        <h3>Komunikat</h3>
        <Type v-on:sendType="getType"/>
        <Range v-on:sendRange="getRange"/>
        <TargetGroup v-on:usersNumber="setNumber" v-on:sendGroup="getGroup"/>
        <AlertLevel v-on:sendLevel="getLevel"/>
        <TopicList v-if="!topicListOn" v-on:sendMessage="getMessage"/>
        <CustomAlert v-if="seletctedMessage" v-on:sendCustomMessage="getCustomMessage" v-on:closeEdition="closeEdition" :key="seletctedMessage" v-bind:buttonName="'Edytuj wybrany komunikat'" v-bind:messageText="seletctedMessage" />
        <CustomAlert v-on:customTextOn="toggleTopicList" v-on:sendCustomMessage="getCustomMessage" v-bind:buttonName="'Napisz własny komunikat'"/>
        <Sendings v-show="null" v-on:sendSendings="getSendings" />
        <div v-if="sendingResult || statusResult" class="result">
            <b-progress :value="sendingIteration" :max="usersNumber" show-value class="progresBar"></b-progress>
            <div>{{sendingResult}}</div>
            <div>{{statusResult}}</div>
        </div>
        <b-button v-b-toggle.collapse-1 variant="primary" class="cmsButton" v-on:click="preparePayload" :disabled='isDisabled'>WYŚLIJ</b-button>
        <b-collapse id="collapse-1" class="mt-2">
            <b-card class="confirmationBlock">
                <p class="card-text">Jesteś pewien, że chcesz wysłać komuikat do {{usersNumber}} {{recivers}}?</p>
                <div class="confirmation">
                    <b-button v-b-toggle.collapse-1 class="yes" v-on:click="send">Tak</b-button>
                    <b-button v-b-toggle.collapse-1 class="no" v-on:click="cancelSending">Nie</b-button>
                </div>
            </b-card>
        </b-collapse>
        <b-button v-b-toggle.collapse-2 variant="primary" class="cmsButton" v-on:click="checkStatus">STATUS</b-button>
        <b-collapse id="collapse-2" class="mt-2">
            <b-card class="confirmationBlock">
                <p><span>Data wysłania wiadomości: </span>{{statusDate}}</p>
                <p><span>Autor: </span>{{statusMessage.author}}</p>
                <p><span>Treść: </span>{{statusMessage.message}}</p>
                <p><span>Grupa: </span>{{statusMessage.group}}</p>
                <p><span>{{statusMessage.level}}</span></p>
                <p><span>{{statusMessage.range}}</span></p>
                <b-progress :value="statusIteration" :max="numberOfPhones" show-value class="progresBar"></b-progress>
                <p v-show="statusIteration != numberOfPhones">Trwa ładowanie statusu numerów</p>
                <p v-show="statusIteration == numberOfPhones">Ładowanie statusu numerów zakończone</p>
                <p v-for="(item, index) in statusNumber" :key="index" v-bind:class="statusText[index] == 'Wiadomość SMS została dostarczona do telefonu' ? green : (statusText[index] == 'Wiadomość SMS oczekuje w SMSC u operatora na dostarczenie do telefonu' ? orange : red)">Nr <span>{{item}}</span> - {{statusText[index]}}</p>
            </b-card>
        </b-collapse>
        <div v-show="isAdmin"><b-button class="cmsButton" v-on:click="startCMS">CMS</b-button></div>
        <div><b-button class="cmsButton" v-on:click="startProfile">PROFIL</b-button></div>
        <div><b-button class="cmsButton" v-on:click="logOut">WYLOGUJ</b-button></div>
    </div>
</template>

<script>
import TargetGroup from './MainComponents/TargetGroup';
import TopicList from './MainComponents/TopicList';
import CustomAlert from './MainComponents/CustomAlert';
import AlertLevel from './MainComponents/AlertLevel';
import Sendings from './MainComponents/Sendings';
import Type from './MainComponents/Type';
import Range from './MainComponents/Range';
import axios from 'axios';
import {bmPath, path} from '../../config';
import {giveTemplate} from '../functions/mailTemplate';
export default {
    name: 'MainApp',
    props: {
        isAdmin: Boolean,
        name: String,
        currentDate: String,
    },
    components: {
        TargetGroup,
        TopicList,
        CustomAlert,
        AlertLevel,
        Sendings,
        Type,
        Range,
    },
    computed: {
        recivers: function(){
            if(this.usersNumber === 1){
                return 'odbiorcy';
            }   else {
                return 'odbiorców';
            }
        },
        isDisabled: function(){
            if(this.selectedGroup && (this.seletctedMessage || this.customMessage)){
                return !this.disabledButton;
            } else {
                return this.disabledButton;
            }
        },
    },
    methods: {
        startCMS: function(){
            this.$emit('startCMS');
        },
        startProfile: function(){
            this.$emit('startProfile');
        },
        toggleTopicList: function(customText){
            this.topicListOn = customText
            this.seletctedMessage = '';
        },
        logOut: function(){
            this.$emit('logOut');
        },
        setNumber: function(usersNumber){
            this.usersNumber = usersNumber;
        },
        getType: function(type){
            this.selectedType = type;
        },
        getRange: function(range){
            this.selectedRange = range;
        },
        getGroup: function(group){
            this.selectedGroup = group;
        },
        getLevel: function(level){
            this.selectedLevel = level;
        },
        getMessage: function(message){
            this.seletctedMessage = message;
        },
        getCustomMessage: function(customMessage){
            this.customMessage = customMessage;
        },
        getSendings: function(sendings){
            this.selectedSendings = sendings;
        },
        closeEdition: function(){
            this.customMessage = '';
        },
        preparePayload: async function(){
            if(!this.seletctedMessage){
                this.finalMessage = this.customMessage;
            } else if(this.seletctedMessage && this.customMessage){
                this.finalMessage = this.customMessage;
            } else{
                this.finalMessage = this.seletctedMessage;
            }
// NIE ZMIENIAĆ ZAPISU ZMIENNEJ fullPayload - ma to wpływ na wygląd wiadomości sms!
            this.fullPayload = {
                type: (this.selectedType ? `Dotyczy: ${this.selectedType},
` : ''),
                range: (this.selectedType ? `${this.selectedRange},
` : ''),
                group: this.selectedGroup,
                level: ( this.selectedLevel ? `${this.selectedLevel},
` : ''),
                message: this.finalMessage,
                send: this.selectedSendings,
            }
            this.setOverlay();
        },
        setOverlay: function(){
            this.overlayOn = true;
        },
        cancelSending: function(){
            this.overlayOn = false;
        },
        checkStatus: async function(){
            this.statusOn = !this.statusOn;
            if(this.statusLoaded === false){
                this.statusLoaded = true;
                await axios
                    .get(`${bmPath}logs/status`)
                    .then(response => (
                        this.statusMessage = response.data,
                        this.numberOfPhones = this.statusMessage.numbersID.length,
                        this.statusDate = this.statusMessage.date
                    ))
                    .catch(e => (
                        console.log(e)
                    ))
                for(let number of this.statusMessage.numbersID){
                    this.statusIteration ++;
                    let keyNumber = (Number(Object.keys(number)));
                    this.statusNumber.push(keyNumber);
                    let numId = number[keyNumber];
                    let payload = {
                        id: numId
                    }
                    if(this.statusMessage.numbersID[0] !== 'wysyłka email'){
                        await axios
                            .post(`${bmPath}status`, payload)
                            .then(response => (
                                this.status = response.data,
                                this.statusText.push(response.data.statusDescription)
                            ))
                            .catch(e => (
                                console.log(e)
                            ))
                    }
                    else {
                     this.statusText = ['Tyko wysyłka email']   
                    }
                } 
                if(!this.statusOn){
                    this.statusText = [];
                    this.statusNumber = [];
                }  
            }
                
        },
        send: async function(){
            this.statusLoaded = false;
            this.statusOn = false;
            this.overlayOn = false;
            this.statusText = [];
            this.statusNumber = [];
            this.resp = [];
            this.statusIteration = 0;
            await axios
            .get(`${path}users`)
            .then(response => (
                this.activeUsers = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            this.sendingResult = 'Wysyłanie wiadomości'
            for(let user of this.activeUsers){
                if(user.groups.includes(this.selectedGroup)){
                    this.sendingIteration ++;
                    let smsData = {
                        phone: user.phoneNumber,
// NIE ZMIENIAĆ ZAPISU WARTOŚCI KLUCZA text - ma wpływ na wygląd wiadomości SMS!
                        text: 
`${this.fullPayload.type}${this.fullPayload.range}${this.fullPayload.level}${this.fullPayload.message}.
${this.name}`,
                        type: "SMS"
                    };
                    if(this.selectedSendings.includes('sms')){
                        await axios
                        .post(bmPath, smsData)
                        .then(response => (
                            this.resp.push(response.data),
                            this.numberId.push({[user.phoneNumber]: response.data.id})
                        ))
                        .catch(e => (
                            console.log(e),
                            this.sendingResult = 'Nie udało się wysłać wiadomości'
                        ))
                        this.sentNumbers.push(user.phoneNumber)
                    }
                    if(this.selectedSendings.includes('email')){
                        let emailData = {
                        email: user.mailAddress,
                        text: 
                        `${giveTemplate(this.fullPayload.type, this.fullPayload.range, this.fullPayload.level, this.fullPayload.message, this.name)}`,
                    };
                        await axios
                        .post(`${path}mails`, emailData)
                        .then(r => console.log(r))
                        .catch(e => console.log(e));
                    }
                }
            }
            this.sendingResult = 'Wiadomość wysłano poprawnie'
            let logPayload = {
                date: (this.selectedSendings.includes('sms') ? this.resp[0].sentTime : this.currentDate),
                message: this.finalMessage,
                group: this.selectedGroup,
                level: (this.selectedLevel ? this.selectedLevel : '-'),
                range: (this.selectedRange ? this.selectedRange : '-'),
                type: (this.selectedType ? this.selectedType : '-'),
                numbersID: (this.selectedSendings.includes('sms') ? this.numberId : ['wysyłka email']),
                author: this.name,
            }
            await axios
                .post(`${bmPath}logs`, logPayload)
                .then(response => (
                    console.log(response.data),
                    this.statusResult = 'Status zapisano poprawnie'
                ))
                .catch(e => (
                    console.log(e),
                    this.statusResult = 'Nie udało sie zapisać statusu'
                ))
            this.numberId = [];

            // Dodatkowa wysyłka sms pod 3 numery telefonu wskazane w tablicy specialNumbers[]
            for(let number of this.specialNumbers){
                if(!this.sentNumbers.includes(number)){
                    console.log('sent sms to: ', number);
                    let smsData = {
                        phone: number,
// NIE ZMIENIAĆ ZAPISU WARTOŚCI KLUCZA text - ma wpływ na wygląd wiadomości SMS!
                        text: 
`${this.fullPayload.type}${this.fullPayload.range}${this.fullPayload.level}${this.fullPayload.message}.
${this.name}`,
                        type: "SMS"
                    };
                    await axios
                        .post(bmPath, smsData)
                        .then(
                        )
                        .catch(e => (
                            console.log(e)
                        ))
                }
            }
        }
    },
    data: function(){
        return{
            topicListOn: false,
            usersNumber: '',
            selectedType: '',
            selectedRange: '',
            selectedGroup: '',
            selectedLevel: '',
            seletctedMessage: '',
            customMessage: '',
            finalMessage: '',
            selectedSendings: '',
            fullPayload: '',
            activeUsers: '',
            resp: [],
            numberId: [],
            logPayload: '',
            overlayOn: false,
            status: '',
            statusText: [],
            statusNumber: [],
            statusOn: false,
            userName: '',
            sendingResult: '',
            statusResult: '',
            statusMessage: '',
            statusDate: '',
            statusLoaded: false,
            sendingIteration: 0,
            statusIteration: 0,
            numberOfPhones: 0,
            disabledButton: true,
            green: 'green',
            red: 'red',
            orange: 'orange',
            specialNumbers: [531592517, 48797005062, 48797005232],
            sentNumbers: [],
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .cmsButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: blue;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
        &:focus{
            background-color: blue;
            border: none;
            box-shadow: none;
        }
    }
    .confirmationBlock{
        z-index: 2;
        border: solid;
        border-color: blue;
        border-width: 3px;
        .confirmation {
            display: flex;
            justify-content: space-evenly;
            .yes {
                background-color: green;
            }
            .no {
                background-color: red;
            }
        }
        span{
            font-weight: bold;
        }
    }
    .overlay {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
        background-color: lightgray;
        opacity: 0.3;
        filter: blur(5px);
        border-radius: 15px;
        cursor: not-allowed;
    }
    .form {
        position: relative;
    }
    .result {
        width: 90%;
        font-size: 18px;
        background-color: white;
        border-radius: 10px;
        border: solid;
        border-color: green;
        border-width: 3px;
        margin: 10px auto;
        align-items: center;
        justify-content: center;
    }
    .progresBar {
        margin: 5px 5px 0 5px;
    }
    .green {
        color: green;
    }
    .red {
        color: red;
    }
    .orange {
        color: orange;
    }
</style>